/** Patterns that should not be shown as user-facing LD titles (bad / test data). */
const LOOKS_LIKE_CODE =
  /console\.(log|debug|info|warn|error)\s*\(|^\s*typeof\s+|debugger\s*;|^\s*eval\s*\(/i;

const GENERIC_PLACEHOLDER = /^(error|err|null|undefined|test|na|n\/a)$/i;

/**
 * Safe label for local depositor nicknames from the API.
 */
export default function formatLdDisplayName(
  raw: string | undefined | null,
  fallback: string
): string {
  const s = (raw ?? '').trim().replace(/\s+/g, ' ');
  if (!s) {
    return fallback;
  }
  if (LOOKS_LIKE_CODE.test(s)) {
    return fallback;
  }
  if (GENERIC_PLACEHOLDER.test(s)) {
    return fallback;
  }
  if (s.length > 72) {
    return `${s.slice(0, 69)}…`;
  }
  return s;
}
